/**
 * Formats a Firestore Timestamp to a readable date string
 * @param {Timestamp} timestamp - Firestore Timestamp object
 * @param {string} locale - Locale string (default: 'en-CA')
 * @returns {string} Formatted date string (e.g., "Jan 2024")
 */
export const formatFirestoreDate = (timestamp, locale = 'en-CA') => {
  if (!timestamp || !timestamp.toDate) {
    return '';
  }

  const dateObj = timestamp.toDate();
  const month = dateObj.toLocaleString(locale, { month: 'short' });
  const year = dateObj.getFullYear();

  return `${month} ${year}`;
};

/**
 * Formats a date range from Firestore Timestamps
 * @param {Timestamp} startDate - Start date Firestore Timestamp
 * @param {Timestamp} endDate - End date Firestore Timestamp
 * @param {string} locale - Locale string (default: 'en-CA')
 * @returns {string} Formatted date range (e.g., "Jan 2024 - Dec 2024")
 */
export const formatDateRange = (startDate, endDate, locale = 'en-CA') => {
  const start = formatFirestoreDate(startDate, locale);
  const end = formatFirestoreDate(endDate, locale);

  if (!start || !end) {
    return '';
  }

  return `${start} - ${end}`;
};
